export const isInvalidDisplayName = (displayName: string): false | string => {
  if (!displayName) {
    return 'Please enter your name.'
  }

  return false
}
